<template>
  <v-navigation-drawer
    v-if="contentList && contentList.length > 0"
    v-model="open"
    width="200"
    fixed
    clipped
    app
    right
    floating
    :mini-variant="isMini"
  >
    <template v-slot:prepend>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title
            class="
              mt-7
              mb-2
              text-h6
              font-weight-medium
              text--primary
              d-flex
              align-center
            "
            ><v-btn class="mr-2" icon small @click="isMini = !isMini"
              ><v-icon v-if="isMini">fa-solid fa-square-caret-left</v-icon>
              <v-icon v-else>fa-solid fa-square-caret-right</v-icon> </v-btn
            >Contenido</v-list-item-title
          >
        </v-list-item-content>
      </v-list-item>
    </template>
    <v-list v-if="!isMini" dense>
      <a
        v-for="(anchor, a) in contentList"
        :key="a"
        :href="anchor.anchorLink"
        class="text-decoration-none"
      >
        <v-list-item :class="isAnchorActive(anchor.anchorLink)">
          <v-list-item-content>{{ anchor.name }}</v-list-item-content>
        </v-list-item>
      </a>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: "FhContentDrawer",
  props: {
    drawer: Boolean,
    contentList: Array,
  },
  data() {
    return {
      title: "",
      isMini: false,
      open: true,
    };
  },
  watch: {
    drawer() {
      this.open = this.drawer;
    },
  },
  computed: {},
  methods: {
    isAnchorActive(anchor) {
      return this.$route.hash === anchor
        ? "v-list-item--active v-list-item v-list-item--link theme--light primary--text"
        : "";
    },
  },
};
</script>

<style>
</style>